import React from 'react'
import { Link } from 'react-router-dom'
import EMITrackerSummary2UI from '../../../components/superUser/loanList/EMITrackerSummary2UI'
import AllRepaymentList2UI from '../../../components/superUser/loanList/AllRepaymentList2UI.js'
import AllRepaymentNavUI from '../../../components/superUser/loanList/AllRepaymentNavUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import SuperUserHomePageUI from '../../../templates/SuperUserHomePageUI.js'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import EmptyListUI from '../../../widgets/output/EmptyListUI'
import SpinnerUI from '../../../widgets/output/SpinnerUI'
import './AllRepaymentListPage.css'

const AllRepaymentListPage2UI = ({ context, errorList, accountList, filteredAccountList, totals, totalLoans,
    totalNonRFLoans, totalRFLoans, onRefreshClick, prepaymentAccountList,
    checked, onShowDetailsChange, onDownloadClick, downloadSubmitted, type,
    onDsraIntClick, onDefaultIntClick, onClearFilter, onShortfallClick, onPrepaidClick,
    view, onViewChange,

}) =>
    <SuperUserHomePageUI context={context} className='pg_su_rp_lst' topnav='accounts' dimension='w1600'
        centered={!accountList && !errorList && !totals} page='repayments'
    >
        {
            !accountList && !errorList && !totals &&
            <SpinnerComponentUI />
        }
        {
            errorList && errorList.length > 0 &&
            <GenericErrorUI error={errorList[0]} />
        }
        <div>
            {
                totals && /*totals.length !== 0 &&*/
                <>
                    <LRTableActionsUI location='top'
                        left={
                            <span className='g_flex_left g_flex_h'>
                                <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
                                <IconButtonUI icon='icon-download' onClick={onDownloadClick} label='Download' />
                                <SpinnerUI className='g_m_left_25' reserveSpace={true} show={downloadSubmitted} />
                                <span className='g_m_left_25 g_large'><b>EMI Tracker, {totals.repaymentMonthYear}</b></span>

                            </span>
                        }
                        right={
                            totals.month && totals.year &&
                            <span>
                                <Link to={`/su/repayments/v2/${type}/${totals.month == 1 ? totals.year - 1 : totals.year}/${totals.month == 1 ? 12 : totals.month - 1}`}>Previous</Link>
                                <span className='g_m_left_100' />
                                <Link to={`/su/repayments/v2/${type}/${totals.month == 12 ? totals.year + 1 : totals.year}/${totals.month == 12 ? 1 : totals.month + 1}`}>Next</Link>
                            </span>
                        }
                    />

                    <AllRepaymentNavUI context={context} type={type} year={totals.year} month={totals.month} version='v2' />

                    <EMITrackerSummary2UI context={context} totals={totals}
                        onDsraIntClick={onDsraIntClick} onDefaultIntClick={onDefaultIntClick}
                        onClearFilter={onClearFilter} onShortfallClick={onShortfallClick}
                        onPrepaidClick={onPrepaidClick}
                    />
                </>
            }
            {
                accountList && accountList.length !== 0 && prepaymentAccountList &&
                <div className='g_m_top_50'>
                    <AllRepaymentList2UI context={context} accountList={filteredAccountList}
                        prepaymentAccountList={prepaymentAccountList}
                        totals={totals} totalLoans={totalLoans} totalNonRFLoans={totalNonRFLoans}
                        totalRFLoans={totalRFLoans} onRefreshClick={onRefreshClick}
                        checked={checked} onShowDetailsChange={onShowDetailsChange}
                        onDownloadClick={onDownloadClick}
                        downloadSubmitted={downloadSubmitted}
                        view={view} onViewChange={onViewChange}
                    />
                </div>
            }
            {
                accountList && accountList.length === 0 &&
                <div className='g_m_top_50'>
                    <span className='g_flex_h'><IconButtonUI icon='icon-refresh' onClick={onRefreshClick} /><span /></span>
                    <EmptyListUI
                        context={context}
                        createEnabled={false}
                        createDisabledMessageLabel='No loans yet'
                    />
                </div>
            }
        </div>


    </SuperUserHomePageUI>

export default AllRepaymentListPage2UI
